import { Card } from 'antd';

export const HelpCard = ({ title, width = 480, children }) => (
  <Card title={title} size="small" bordered={false} style={{ width }}>
    {children}
  </Card>
);
